"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIGHLIGHT_RANGE_START = exports.HIGHLIGHT_RANGE_END = void 0;
exports.getHighlightRanges = getHighlightRanges;
exports.globalFilterWithHighlighting = void 0;
var HIGHLIGHT_RANGE_START = exports.HIGHLIGHT_RANGE_START = 0;
var HIGHLIGHT_RANGE_END = exports.HIGHLIGHT_RANGE_END = 1;

/**
 * https://github.com/pi-kei/tanstack-table/tree/example-react-filters-with-highlighting/examples/react/filters-with-highlighting
 */

function find(value, term) {
  var ranges = undefined;
  var position = 0;
  while (true) {
    var startIndex = value.indexOf(term, position);
    if (startIndex < 0) break;
    if (!ranges) ranges = [];
    ranges.push([startIndex, startIndex + term.length]);
    position = startIndex + term.length;
  }
  return ranges;
}
var globalFilterWithHighlighting = function globalFilterWithHighlighting(row, columnId, filterValue) {
  var filterConfig = filterValue;
  if (!filterConfig.columns) {
    filterConfig.columns = row.getAllCells().filter(function (cell) {
      return cell.column.getCanGlobalFilter();
    }).map(function (cell) {
      return cell.column.id;
    });
  }
  var allCols = filterConfig.columns;
  // Perform global filtering only when columnId=firstColumnId
  if (columnId !== allCols[0]) return false;
  var filterTerms = filterConfig.resolvedTerms;
  var filterTermsFound = filterConfig.termsFound.fill(false);
  var _iterator = _createForOfIteratorHelper(allCols),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var colId = _step.value;
      var value = row.getValue(colId);
      var valueStr = void 0;
      if (typeof value === 'string') {
        valueStr = value.toLowerCase();
        valueStr = valueStr.replace(/\n/g, ' ');
      } else {
        continue;
      }
      var globalFilterRanges = undefined;
      for (var i = 0; i < filterTerms.length; ++i) {
        var ranges = find(valueStr, filterTerms[i]);
        if (ranges) {
          var _globalFilterRanges2;
          filterTermsFound[i] = true;
          if (!globalFilterRanges) globalFilterRanges = [];
          (_globalFilterRanges2 = globalFilterRanges).push.apply(_globalFilterRanges2, _toConsumableArray(ranges));
        }
      }

      // Hacky way to change filter meta for different columns
      row.columnFiltersMeta[colId] = _objectSpread({}, row.columnFiltersMeta[colId], {
        globalFilterRanges: globalFilterRanges
      });
    }
    // Row is passing filter only when all filter terms found in this row
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return filterTermsFound.every(function (found) {
    return found;
  });
};
exports.globalFilterWithHighlighting = globalFilterWithHighlighting;
globalFilterWithHighlighting.resolveFilterValue = function (filterValue) {
  if (filterValue.multiterm) {
    var filter = filterValue.term.split(/\s+/).filter(function (term) {
      return !!term;
    });
    if (filter.length === 0) throw new Error('Filter cannot be empty');
    return _objectSpread({}, filterValue, {
      resolvedTerms: filter.map(function (term) {
        return term.toLowerCase();
      }),
      termsFound: new Array(filter.length).fill(false)
    });
  }
  return _objectSpread({}, filterValue, {
    resolvedTerms: [filterValue.term.toLowerCase()],
    termsFound: [false]
  });
};

// Grouping rows are not processed by the FilterFn (globalFilterWithHighlighting)
// so it does not have any "columnFiltersMeta". So we need to get the "columnFiltersMeta",
// from an actual row using an "id".
function getRangesForGroup(cellContext) {
  var row = cellContext.row;
  var globalFilterRanges = undefined;

  // If a grouping column, get globalFilterRanges from original row
  if (row.groupingColumnId) {
    var _origRow$columnFilter;
    var globalFilter = cellContext.table.getState().globalFilter;
    var groupingColumnId = row.groupingColumnId;
    var filterRows = cellContext.table.getFilteredRowModel();
    var id = row.original.id;
    var origRow = filterRows.rowsById[id];
    globalFilterRanges = globalFilter !== null && globalFilter !== void 0 && globalFilter.term ? (_origRow$columnFilter = origRow.columnFiltersMeta[groupingColumnId]) === null || _origRow$columnFilter === void 0 ? void 0 : _origRow$columnFilter.globalFilterRanges : undefined;
  }
  return globalFilterRanges;
}
function getHighlightRanges(cellContext) {
  var _cellContext$row$colu, _globalFilterRanges;
  // Highlight ranges stored in columnFiltersMeta
  // globalFilterRanges from global filter
  // columnFilterRanges from individual column filter
  // Meta may remain even if filter is empty so we have to check if filter is empty
  var globalFilter = cellContext.table.getState().globalFilter;
  var globalFilterRanges = globalFilter !== null && globalFilter !== void 0 && globalFilter.term ? (_cellContext$row$colu = cellContext.row.columnFiltersMeta[cellContext.column.id]) === null || _cellContext$row$colu === void 0 ? void 0 : _cellContext$row$colu.globalFilterRanges : undefined;
  if (globalFilterRanges === undefined && cellContext.row.groupingColumnId !== undefined) {
    globalFilterRanges = getRangesForGroup(cellContext);
  }

  // Concat all ranges in one array
  // Sort ranges by start index
  var ranges = _toConsumableArray((_globalFilterRanges = globalFilterRanges) !== null && _globalFilterRanges !== void 0 ? _globalFilterRanges : []).sort(function (rangeA, rangeB) {
    return rangeA[HIGHLIGHT_RANGE_START] - rangeB[HIGHLIGHT_RANGE_START];
  });

  // Merge ranges if they overlap
  var i = 0;
  var j = 1;
  while (j < ranges.length) {
    if (ranges[i][HIGHLIGHT_RANGE_END] >= ranges[j][HIGHLIGHT_RANGE_START]) {
      ranges[j][HIGHLIGHT_RANGE_START] = ranges[i][HIGHLIGHT_RANGE_START];
      ranges[j][HIGHLIGHT_RANGE_END] = Math.max(ranges[i][HIGHLIGHT_RANGE_END], ranges[j][HIGHLIGHT_RANGE_END]);
      ranges.splice(i, 1);
    } else {
      i++;
      j++;
    }
  }
  return ranges;
}